import { render, staticRenderFns } from "./VGanttCanvas.vue?vue&type=template&id=8706f7ea&"
import script from "./VGanttCanvas.vue?vue&type=script&lang=ts&"
export * from "./VGanttCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./VGanttCanvas.vue?vue&type=style&index=0&id=8706f7ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports